<div
  class="filters-panel"
  [class]="showHideClass()"
  [class.mobile]="isMobileScreen()">
  @if (isMobileScreen()) {
    <div class="header">
      <p class="ui-label-l-bold">Filters</p>
      <button rds-icon-button size="m" (click)="hideMenu()">
        <rds-icon icon="close"></rds-icon>
      </button>
    </div>
  }

  <bsh-char-filter (filters)="applyFilters($event)"></bsh-char-filter>
</div>
